// Customer hostnames (reviews.acme.com) reach this app through Cloudflare for SaaS with their own Host header.
// pages/_middleware.js rewrites them to the page they are connected to, and the public pages use the host for
// their canonical URLs. Everything here runs in the edge runtime too, so keep it dependency free.
const CUSTOM_DOMAIN_PATHS = {
  wallOfLove: 'wall-of-love',
  reviewBooster: 'booster',
};

function hostnameOf(url) {
  try {
    return new URL(url).hostname.toLowerCase();
  } catch(err) {
    return '';
  }
}

const OWN_HOSTS = [process.env.NEXT_PUBLIC_FRONT, process.env.NEXT_PUBLIC_DOMAIN_ROOT].map(hostnameOf).filter(Boolean);
// shapo.io for production, localhost in development
const ROOT_DOMAIN = hostnameOf(process.env.NEXT_PUBLIC_DOMAIN_ROOT).split('.').slice(-2).join('.');

export function isShapoHost(host) {
  if(!host) {
    return true;
  }
  if(OWN_HOSTS.includes(host) || host === ROOT_DOMAIN || host.endsWith(`.${ROOT_DOMAIN}`)) {
    return true;
  }
  return host === 'localhost' || host.endsWith('.localhost') || /^\d+\.\d+\.\d+\.\d+$/.test(host);
}

// the customer hostname a request came in on, or null when it is one of ours
export function getCustomHost(hostHeader) {
  const host = String(hostHeader || '').split(':')[0].toLowerCase();
  return isShapoHost(host) ? null : host;
}

export function getCustomDomainPath(target) {
  const path = CUSTOM_DOMAIN_PATHS[target.type];
  return path ? `/${path}/${target.publicId}` : null;
}
